export function buildContactCopyText(
  name?: string | null,
  phone?: string | null,
  email?: string | null
): string {
  return [name, phone, email]
    .map((value) => (value || '').trim())
    .filter(Boolean)
    .join('\n');
}

export function buildCustomerSectionCopyText(
  name?: string | null,
  address?: string | null,
  email?: string | null,
  phone?: string | null
): string {
  return [name, address, email, phone]
    .map((value) => (value || '').toString().trim())
    .filter((value) => !!value && value !== '-')
    .join('\n');
}

export async function copyToClipboard(text: string): Promise<boolean> {
  const normalizedText = (text || '').trim();
  if (!normalizedText) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(normalizedText);
      return true;
    }
  } catch {}

  const textarea = document.createElement('textarea');
  textarea.value = normalizedText;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);

  return copied;
}
